module.exports = __webpack_public_path__ + "static/media/notification.fff09c96.png";